import { Suspense } from 'react';
import GlobalNavbar from '../../components/feature/GlobalNavbar';
import Footer from '../home/components/Footer';

export default function Terms() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <GlobalNavbar />
        
        {/* Dark Hero Banner - matches other pages */}
        <section className="relative bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 pt-32 pb-16 px-6">
          <div className="max-w-[900px] mx-auto">
            <h1 className="text-4xl font-bold text-white mb-4">利用規約</h1>
            <p className="text-sm text-gray-400">最終更新日：2026年1月</p>
          </div>
        </section>

        <main className="py-20">
          <div className="max-w-[900px] mx-auto px-8">
            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第1条（本規約への同意）</h2>
                <p className="mb-4">
                  本ウェブサイトおよびDOOHNUTS Inc.（以下「当社」といいます）が提供するサービスをご利用いただくことにより、利用者は本利用規約（以下「本規約」といいます）に同意したものとみなされます。
                </p>
                <p className="mb-4">
                  本規約に同意されない場合は、当社サービスをご利用いただけません。
                </p>
                <p>
                  本規約は、広告主、看板オーナー、投資検討者、閲覧者その他当社サービスを利用するすべての方に適用されます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第2条（サービス内容）</h2>
                <p className="mb-4">
                  当社は、ネバダ州ラスベガスおよびその周辺地域において、デジタルおよび物理看板に関する広告サービスを提供します。
                </p>
                <p className="mb-4">
                  提供サービスには以下が含まれますが、これらに限定されません。
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>看板広告枠の貸出および管理</li>
                  <li>デジタル広告企画および運用</li>
                  <li>看板資産に関するパートナーシップ協議</li>
                  <li>ROIシミュレーションおよび分析資料の提供</li>
                  <li>広告および投資に関するコンサルティング</li>
                </ul>
                <p>
                  当社は、事前通知なくサービス内容を変更、中断、終了することができます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第3条（利用資格）</h2>
                <p>
                  利用者は18歳以上であり、法的拘束力のある契約を締結できる能力を有している必要があります。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第4条（広告コンテンツ）</h2>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>広告内容は掲載前に当社の承認を受ける必要があります。</li>
                  <li>当社は、法令違反、社会的相当性を欠く内容、または当社基準に反する内容を拒否または削除する権利を有します。</li>
                  <li>広告内容に関する法的責任は、すべて利用者が負うものとします。</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第5条（知的財産）</h2>
                <p className="mb-4">
                  本サイトおよび当社サービスに含まれるすべてのコンテンツ、ロゴ、デザイン、文章、画像、ソフトウェア等の知的財産権は当社または正当な権利者に帰属します。
                </p>
                <p>
                  無断使用を禁止します。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第6条（投資およびROIに関する免責）</h2>
                <p className="mb-4">
                  当社が提供する収益予測、ROIシミュレーション、分析資料、投資に関する説明は情報提供目的であり、金融・投資・税務・法的助言を構成するものではありません。
                </p>
                <p className="mb-4">
                  将来の成果を保証するものではありません。
                </p>
                <p>
                  利用者は自己の責任において判断を行うものとします。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第7条（保証の否認）</h2>
                <p className="mb-4">
                  当社サービスは「現状有姿（AS IS）」で提供されます。
                </p>
                <p>
                  当社は、明示または黙示を問わず、特定目的適合性、商品性、非侵害性を含む一切の保証を行いません。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第8条（責任の制限）</h2>
                <p className="mb-4">
                  適用法の許す最大限の範囲において、
                </p>
                <p className="mb-4">
                  当社は、間接損害、特別損害、結果的損害、逸失利益、データ損失等について一切責任を負いません。
                </p>
                <p>
                  当社の賠償責任は、請求原因となった事由発生前12か月間に利用者が当社へ支払った金額を上限とします。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第9条（補償）</h2>
                <p className="mb-4">
                  利用者は、以下に関連して当社に生じた損害・請求・費用（弁護士費用含む）を補償するものとします。
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>本サービスの利用</li>
                  <li>広告内容</li>
                  <li>本規約違反</li>
                  <li>第三者の権利侵害</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第10条（不可抗力）</h2>
                <p>
                  天災、停電、政府規制、法令変更、通信障害その他当社の合理的支配を超える事由により発生した遅延または不履行について、当社は責任を負いません。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第11条（契約終了）</h2>
                <p>
                  当社は、利用者が本規約に違反した場合、または必要と判断した場合、事前通知なくサービス提供を停止または終了することができます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第12条（準拠法および紛争解決）</h2>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>本規約は、アメリカ合衆国ネバダ州法に準拠します。</li>
                  <li>本規約に関連して生じる紛争は、ネバダ州ラスベガスにおける拘束力ある仲裁により解決されるものとします。</li>
                  <li>利用者は陪審裁判を受ける権利を放棄します。</li>
                  <li>集団訴訟への参加権を放棄します。</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第13条（分離可能性）</h2>
                <p>
                  本規約の一部が無効となった場合でも、その他の規定は有効に存続します。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第14条（完全合意）</h2>
                <p>
                  本規約は、当社と利用者との間の完全な合意を構成します。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">第15条（お問い合わせ）</h2>
                <div className="bg-gray-50 p-6 rounded-lg mt-4">
                  <p className="font-semibold text-gray-900 mb-2">DOOHNUTS Inc.</p>
                  <p className="text-sm">ネバダ州ラスベガス</p>
                  <p className="text-sm">Email：<a href="mailto:info@doohnutsinc.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">info@doohnutsinc.com</a></p>
                  <p className="text-sm">Phone：<a href="tel:+17024779870" className="text-teal-600 hover:text-teal-700 cursor-pointer">+1 (702) 477-9870</a></p>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </Suspense>
  );
}
